module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/japan.6990e7c5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/japan.png
// module id = 2790
// module chunks = 11